module.exports = __webpack_public_path__ + "static/media/piggy-bank.0463fbc1.jpg";